import { Injectable, Optional } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse
} from '@angular/common/http';
import { AuthService } from '../services';
import { CacheService } from '../services';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const TTL = 120;

@Injectable({
  providedIn: 'root'
})
export class CacheInterceptor implements HttpInterceptor {

  /**
 * Creates an instance of the CacheInterceptor which @implements the class HttpInterceptor
 *
 * @param {CacheService} cache Injected instance of CacheService
 * @param {AuthService} auth Injected instance of AuthService
 */
  constructor(private cache: CacheService, @Optional() private auth: AuthService) { }

  /**
  * Intercepts and returns cached response of HTTP GET requests. Sends request if there is no cached response.
  * @param req — The outgoing request object to handle.
  * @param next
  * The next interceptor in the chain, or the backend if no interceptors remain in the chain.
  *@returns — An observable of the event stream.
 */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }
    setTimeout(() => { }, 0);
    const cachedResponse = this.cache.get(this.auth.domain, req);
    return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next);
  }

  /**
  * Sends request to backend and caches response
  * @param req — The outgoing request object to handle.
  * @param next
  * The next interceptor in the chain, or the backend if no interceptors remain in the chain.
  *@returns — An observable of the event stream.
 */
  private sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.cache.put(this.auth.domain, req, event, TTL);
        }
      })
    );
  }

}
